import { render, staticRenderFns } from "./ModalSearchIsIdentificator.vue?vue&type=template&id=604e9540&scoped=true&"
import script from "./ModalSearchIsIdentificator.vue?vue&type=script&lang=js&"
export * from "./ModalSearchIsIdentificator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604e9540",
  null
  
)

export default component.exports